import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import labImage from '../../images/lab_tester.jpg';

import './TesterComponent.scss'

const TesterComponent = () => {
    return <>
        <Row>
            <Col>
                <div className="text-lab mt-4">
                    <h4>Bienvenue au Lab&#8239;!</h4>
                    <h5 className="mt-4">Vous faites partie du Lab, notre communauté d’utilisateur·ices qui ont envie de partager leurs avis et bonnes idées.</h5>
                    <p className="fw-bold mb-1 mt-4">En tant que bêta-testeur·euse, vous pouvez avoir accès à&nbsp;:</p>
                    <ul>
                        <li>de nouvelles fonctionnalités&#8239;;</li>
                        <li>de nouveaux formats d’expériences immersives&#8239;;</li>
                        <li>de nouvelles modalités d’accompagnement&#8239;;</li>
                        <li>et bien d’autres choses encore au fil des sujets dont nous voulons discuter avec vous&#8239;!</li>
                    </ul>
                    <p className="mt-4">Prenons le temps d’échanger et réfléchissons ensemble aux outils et ressources les plus adaptés aux besoins de vos publics. Peut-être que certaines pistes que vous aurez proposées verront le jour&#8239;!</p>
                </div>
                <div className="text-lab mt-4 mb-4">
                    <h4>Nos axes de réflexion</h4>
                    <p className="mb-1">
                        Nous réfléchissons aux <b>futures évolutions de nos outils</b> et nous avons besoin d’en savoir plus sur vos usages&#8239;!
                    </p>
                    <ul>
                        <li>Pourquoi utilisez-vous Métiers 360&#8239;?</li>
                        <li>Auprès de quel public&#8239;?</li>
                        <li>Qu’utilisez-vous concrètement&#8239;? (expériences immersives de découverte des métiers, expériences interactives, playlists, webapp, modules pédagogiques, backoffice…)</li>
                        <li>Quels sont pour vous les points positifs de notre solution&#8239;?</li>
                        <li>Qu’est-ce qu’il faudrait que l’on améliore&#8239;?</li>
                    </ul>

                    <div className="lab-end-card mt-4">
                        <b><u>Pour nous faire part de vos retours&nbsp;:</u></b>
                        <p>
                            Vous pouvez nous envoyer un mail, participer aux rendez-vous du Lab (invitations
                            envoyées par nos soins) et/ou réserver un créneau dans notre agenda&#8239;!
                        </p>
                        <Button
                            variant="primary"
                            href="https://calendar.app.google/4ckGNCRacwFVUPuKA"
                            target="_blank">
                            J’accède à l’agenda
                        </Button>
                    </div>
                </div>
            </Col>
            <Col xl={12} xxl={6} className="col-img-lab">
                <img src={labImage} alt="" className="lab-image" />
            </Col>
        </Row>
        <Row>
            <Col className="text-lab">
                <h4 className="mt-2">Merci, nous avons hâte de voir ce que vous en pensez&#8239;!</h4>
            </Col>
        </Row>
    </>
}
export default TesterComponent;
